// sensei-app/client/widgets/NextActivityWidget.widget.js

export default {
    name: "NextActivityWidget",
    type: "DataWidget", // Correctly uses DataWidget
    description: "Displays the student's next scheduled activity in an engaging card.",
    roles: ["student"],
    widget: {
        title: "What's Next?",
        size: "medium",

        // >>> THE NEW UNIFIED DATA PROVIDER CONFIGURATION <<<
        dataProvider: {
            main: { // The 'main' key is used by DataWidget's renderContent
                rpc: "StudentRpc.getNextActivity",
                transform: (data) => data ? [data] : [] // Wraps single object in an array
            }
        },

        viewMode: "list", // Important for custom itemTemplate to take full control

        // The itemTemplate remains the same as our previous successful version
        itemTemplate: (item) => {
            const getActivityDetails = (topicType) => {
                switch (topicType) {
                    case 'class': return { icon: 'bi-camera-video-fill', text: 'Start Class', link: `/student/classroom?scheduleId=${item._id}` };
                    case 'assessment': return { icon: 'bi-clipboard2-check-fill', text: 'Begin Assessment', link: `/student/assessment?scheduleId=${item._id}` };
                    case 'assignment': return { icon: 'bi-file-earmark-arrow-up-fill', text: 'Start Assignment', link: `/student/assignment?scheduleId=${item._id}` };
                    default: return { icon: 'bi-question-circle-fill', text: 'Start', link: '#' };
                }
            };
            const { icon, text, link } = getActivityDetails(item.topicType);
            const scheduledTime = new Date(item.scheduledDateTime).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
            return `
                <style>
                    .next-activity-card { background: linear-gradient(135deg, var(--bs-primary-bg-subtle), var(--bs-primary)); color: var(--bs-primary-contrast, #fff); border-radius: var(--bs-border-radius-lg); text-align: center; padding: 1.5rem; transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out; height: 100%; display: flex; flex-direction: column; justify-content: center; }
                    .next-activity-card:hover { transform: translateY(-5px); box-shadow: var(--bs-box-shadow-lg); }
                    .next-activity-card .activity-icon { font-size: 3rem; margin-bottom: 0.5rem; opacity: 0.8; }
                    .next-activity-card .activity-title { font-size: 1.5rem; font-weight: 600; }
                    .next-activity-card .activity-details { font-size: 0.9rem; opacity: 0.9; }
                    .next-activity-card .btn-start-now { margin-top: 1.25rem; font-weight: 500; padding: 0.6rem 1.5rem; }
                </style>
                <div class="next-activity-card">
                    <div class="activity-icon"><i class="bi ${icon}"></i></div>
                    <h4 class="activity-title">${item.topicTitle}</h4>
                    <div class="activity-details">
                        <span>${item.courseName}</span> • <span>${scheduledTime}</span>
                    </div>
                    <a href="${link}" class="btn btn-light btn-start-now">
                        ${text} <i class="bi bi-arrow-right-short"></i>
                    </a>
                </div>`;
        },
        
        noDataMessage: "You're all caught up! Great job! ✨"
    }
};